export default function InfoPanelDivider() {
  return (
    <div className="py-6 md:py-8" aria-hidden="true">
      <div className="border-t border-gray-300" />
    </div>
  );
}
